import { Component, OnInit, Input, ChangeDetectionStrategy } from '@angular/core';
import { ModalController, LoadingController, AlertController, Platform } from '@ionic/angular/lazy';
import { APIService } from 'src/app/services/api.service';
import { AuthService } from 'src/app/services/auth.service';
import { Router } from '@angular/router';
import { OrderService } from 'src/app/services/order.service';
import { ObserverService } from 'src/app/services/observer.service';
import { CashDrawerService } from 'src/app/services/cash-drawer.service';
import { StorageService } from 'src/app/services/storage.service';
import { PersonService } from 'src/app/services/person.service';
import { OrganisationService } from 'src/app/services/organisation.service';
import { Decimal } from "decimal.js";
import moment from 'moment-timezone';
import { DateTimePickerPage } from 'src/app/modals/date-time-picker/date-time-picker.page';
import { ConnectedAccountService } from 'src/app/services/connected-account.service';
import { SmartpayReaderService } from 'src/app/services/smartpay-reader.service';
import { CustomPaymentServiceService } from "src/app/services/custom-payment-service.service";
import { Capacitor } from '@capacitor/core';

@Component({
    selector: 'app-order-refund-payment-add',
    templateUrl: './order-refund-payment-add.page.html',
    styleUrls: ['./order-refund-payment-add.page.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})

export class OrderRefundPaymentAddPage implements OnInit {

    spinner = null;
    loading_spinner = null;
    loading = false;
    online = true;
    moment = moment;
    user = null;
    @Input() order_id = null;
    order = null;
    @Input() refund_id = null;
    refund = null;
    smartpay_connected = false;
    has_stripe_payments = false;
    xero_connected = false;
    stripe_connected = false;
    credit_card_payments = [];
    amount_due = 0.00;
    receipt_printer = null;
    formatted_date = null;
    date_modal_css_class = '';
    custom_payment_services = [];
    settings = null;

    params: any = {
        method: 'cash',
        date: null,
        price: 0,
        originating_payment_id: null,
        add_xero_credit_note_payment: false,
        payment_service_transaction_id: undefined,
        payment_service_id: undefined
    };

    // modal flags
    date_picker_modal_open = false;

    constructor(
        private router: Router,
        private apiService: APIService,
        private authService: AuthService,
        public modalController: ModalController,
        public alertController: AlertController,
        private loadingController: LoadingController,
        private orderService: OrderService,
        private observerService: ObserverService,
        private platform: Platform,
        private storageService: StorageService,
        private personService: PersonService,
        private organisationService: OrganisationService,
        private connectedAccountService: ConnectedAccountService,
        private smartpayReaderService: SmartpayReaderService,
        private customPaymentServiceService: CustomPaymentServiceService,
        private cashDrawerService: CashDrawerService
    ) { }

    ngOnInit() {

        if(Capacitor.isNativePlatform()) {
            this.date_modal_css_class = 'backdrop';
        }

        this.storageService.get('register_id').then((register_id) => {
            this.params['register_id'] = register_id;
        })
        .catch (() => {})

        if(this.refund_id) {


            if(this.order_id) {


                this.loadData().then(() => {

                    if(this.order.payments) {
                        for(let i = 0; i < this.order.payments.length; i++) {
                            if(this.order.payments[i].method == 'credit_card') {
                                if(this.smartpay_connected) {
                                    this.credit_card_payments.push(this.order.payments[i]);
                                } else if(this.order.payments[i].payment_service && this.order.payments[i].payment_service.friendly_id == "stripe") {
                                    this.credit_card_payments.push(this.order.payments[i]);
                                    this.has_stripe_payments = true;
                                }
                            }
                        }
                        // Note: Any new credit_card methods will need to be added above
                    }

                    this.amount_due = this.refund.total_price;

                    if(this.refund.payments) {
                        for(let i = 0; i < this.refund.payments.length; i++) {
                            this.amount_due = Number(new Decimal(this.amount_due).minus(this.refund.payments[i].price).toDecimalPlaces(2));
                        }
                    }

                    this.params.price = this.amount_due;

                    if(this.credit_card_payments.length != 0) {
                        this.params.method = 'credit_card';
                        this.params.originating_payment_id = this.credit_card_payments[0].id;
                        if(this.credit_card_payments[0].payment_service && this.credit_card_payments[0].payment_service.friendly_id == "stripe") {
                            this.params.price = this.credit_card_payments[0].price;
                        }
                    }

                    this.params.date = this.moment().toISOString(true);
                    this.formatted_date = this.moment(this.params['date']).format("D MMM YYYY, HH:mm");

                    if(this.params.price > this.amount_due) {
                        this.params.price = this.amount_due;
                    }

                })
                .catch(() => { });

            }

        }

        this.platform.ready().then(() => {
            if(Capacitor.isNativePlatform()) {
                this.storageService.get("receipt_printer").then((receipt_printer) => {
                    if(receipt_printer) {
                        this.receipt_printer = receipt_printer;
                    }
                });
            }
        });

        this.customPaymentServiceService.getCustomPaymentServices().then((custom_payment_services:[]) => {
            if(custom_payment_services) {
                this.custom_payment_services = custom_payment_services;
            }
        })

        this.observerService.subscribe("custom_payment_services_changed|order_refund_payment_add_modal", custom_payment_services => {
            if(custom_payment_services) {
                this.custom_payment_services = custom_payment_services;
            }
        })

        this.observerService.subscribe("custom_payment_service_added|order_refund_payment_add_modal", custom_payment_service => {
            if(custom_payment_service) {
                this.custom_payment_services.push(custom_payment_service);
            }
        })

        this.observerService.subscribe("custom_payment_service_deleted|order_refund_payment_add_modal", custom_payment_service_id => {
            if(custom_payment_service_id) {
                for(let i = 0; i < this.custom_payment_services.length; i++) {
                    if(this.custom_payment_services[i].id == custom_payment_service_id) {
                        this.custom_payment_services.splice(i, 1);
                        break;
                    }
                }
            }
        })

        this.observerService.subscribe("custom_payment_service_updated|order_refund_payment_add_modal", custom_payment_service => {
            if(custom_payment_service) {
                for(let i = 0; i < this.custom_payment_services.length; i++) {
                    if(this.custom_payment_services[i].id == custom_payment_service['id']) {
                        this.custom_payment_services[i] = custom_payment_service;
                        break;
                    }
                }
            }
        })

        this.observerService.subscribe('network_status_changed|order_refund_payment_add_modal', (network_status) => {
            if(network_status) {
                this.online = network_status.connected;
                if(this.online) {
                    this.loadData().then(() => { }).catch(() => { });
                }
                else {
                    this.presentAlert("Offline", "You must be online to add a payment, please check your network connection and try again.");
                }
            }
        });

        this.storageService.get("smartpay_reader").then((reader) => {
            if(reader) {
                this.smartpay_connected = true;
                this.params.method = 'credit_card';
            }
        });

    }

    ngOnDestroy() {
        this.observerService.destroy("custom_payment_services_changed|order_refund_payment_add_modal");
        this.observerService.destroy("custom_payment_service_added|order_refund_payment_add_modal");
        this.observerService.destroy("custom_payment_service_deleted|order_refund_payment_add_modal");
        this.observerService.destroy("custom_payment_service_updated|order_refund_payment_add_modal");
        this.observerService.destroy("network_status_changed|order_refund_payment_add_modal");
    }

    loadData() {
        let promise = new Promise<void>((resolve, reject) => {
            this.presentLoadingSpinner("Loading refund").then(() => {
                this.loadOrderRefund().then(() => {
                    this.loading_spinner.message = "Loading order";
                    this.loadOrder().then(() => {
                        this.loading_spinner.message = "Loading settings";
                        this.loadSettings().then(() => {
                            if(this.settings.stripe_connected == "true") {
                                this.stripe_connected = true;
                            }
                            if(this.settings.xero_connected == "true") {
                                this.xero_connected = true;
                            }
                            if(this.xero_connected && this.refund.xero_credit_note_id) {
                                this.params.add_xero_credit_note_payment = true;
                            }
                            this.loading_spinner.dismiss();
                            resolve();
                        })
                        .catch(() => {
                            this.loading_spinner.dismiss();
                            reject();
                        });
                    })
                    .catch(() => {
                        this.loading_spinner.dismiss();
                        reject();
                    });
                })
                .catch(() => {
                    this.loading_spinner.dismiss();
                    reject();
                });
            });
        });
        return promise;
    }

    loadSettings() {
        return new Promise<void>((resolve, reject) => {
            this.authService.isLoggedIn().then(() => {
                this.storageService.get("connected_account_id").then(connected_account_id => {
					if (connected_account_id) {
						this.connectedAccountService.getConnectedAccount(connected_account_id).then(connected_account => {
                            if (connected_account) {
                                this.apiService.getSettings(connected_account).then((settings: {}) => {
                                    if(settings) {
                                        this.settings = settings;
                                    }
                                    resolve();
                                })
                                .catch((error) => {
                                    if(error.status === 400) {
                                        this.presentAlert('Unknown error', "Unfortunately something went wrong when trying to retrieve the settings.");
                                    }
                                    else if(error.status == 403) {
                                        this.presentAlert('Insufficient permissions', "You don't have permission to view settings.");
                                    }
                                    else if(error.status == 404) {
                                        this.presentAlert('Unavailable', "Unfortunately we're unable to retrieve settings at this time.");
                                    }
                                    else if(error.status == 0) {
                                        this.presentAlert("Connection failure", "Unable to reach the server. Please try again.");
                                    }
                                    reject();
                                });
                            }
                            else {
                                reject();
                            }
                        })
                        .catch(error => {
                            reject(error);
                        });
					}
                    else {
						reject();
					}
				})
				.catch(error => {
					reject(error);
				});
            })
            .catch(() => {
                this.router.navigate(['switch-account'], { replaceUrl: true }).then(() => {
                    window.location.reload();
                });
            });
        });
    }

    loadOrderRefund() {
        let promise = new Promise<void>((resolve, reject) => {
            this.refund = null;
            this.orderService.getOrderRefund(this.order_id, this.refund_id).then((refund) => {
                if(refund) {
                    this.refund = refund;
                }
                resolve();
            })
            .catch(() => {
                reject();
            });
        });
        return promise;
    }

    loadOrder() {
        let promise = new Promise<void>((resolve, reject) => {
            this.order = null;
            this.orderService.getOrder(this.order_id).then((order) => {
                if(order) {
                    this.order = order;
                }
                resolve();
            })
            .catch(() => {
                reject();
            });
        });
        return promise;
    }

    close() {
        this.modalController.dismiss();
    }

    add() {

        let validated = true;

        if(this.params.price == null || this.params.price == undefined) {
            validated = false;
            this.presentAlert('Missing amount', 'Please enter an amount');
        }
        else if(isNaN(this.params.price) || this.params.price <= 0) {
            validated = false;
            this.presentAlert('Invalid amount', 'Please ensure the amount is a valid number greater than zero.');
        }
        else if(this.params.price > this.amount_due) {
            validated = false;
            this.presentAlert('Amount exceeds amount due', "Please ensure the amount doesn't exceed the amount due for this refund.");
        }

        if(this.params['date'] == null || this.params['date'].trim() === "") {
            validated = false;
            this.presentAlert("Missing date", "Please select a date");
        }

        if(this.params.method == "custom") {

            if(!this.params.payment_service_id) {
                validated = false;
                this.presentAlert("Missing custom payment service", "Please select a custom payment service.");
            }

        }

        if(validated) {

            this.params['date'] = this.moment(this.params['date']).utc().toISOString();

            if(this.params.method != 'credit_card') {
                delete this.params.originating_payment_id;
            }

            this.addOrderRefundPayment().then(() => {
                this.modalController.dismiss();
            });

        }

    }

    smartpay_refund_loading: HTMLIonLoadingElement = null;
    smartpay_refund_alert: HTMLIonAlertElement = null;
    smartpay_transaction_start_time = 0;
    smartpayRefundLoadingController() {
        this.loadingController.create({
            message: "Awaiting payment..."
        }).then(loading => {
            this.smartpay_refund_loading = loading;
            loading.backdropDismiss = true;
            loading.onDidDismiss().then((ev) => {
                if(!ev.data) {
                    if(Date.now() - this.smartpay_transaction_start_time < 60_000) {
                        this.alertController.create({
                            header: "Payment in progress...",
                            message: "Please cancel on the device",
                            backdropDismiss: true,
                            buttons: [{text: "OK", handler: () => {this.smartpay_refund_alert.dismiss()}}]
                        }).then(alert => {
                            this.smartpay_refund_alert = alert;
                            alert.backdropDismiss = true;
                            alert.onDidDismiss().then((ev) => {
                                if(!ev.data) {
                                    if(Date.now() - this.smartpay_transaction_start_time < 60_000) {
                                        this.smartpayRefundLoadingController();
                                    } else {
                                        this.smartpayReaderService.clearCurrentTransaction();
                                    }
                                }
                            });
                            alert.present();
                        });
                    } else {
                        this.smartpayReaderService.clearCurrentTransaction();
                    }
                }
            });
            loading.present();
        });
    }

    addOrderRefundPayment() {
        return new Promise<void>((resolve, reject) => {
            if(this.params.method == 'credit_card') {
                let originating_payment = this.credit_card_payments.find(payment => payment.id == this.params.originating_payment_id);
                let is_stripe_payment = false;
                if(originating_payment) {
                    is_stripe_payment = originating_payment.payment_service && originating_payment.payment_service.friendly_id == "stripe";
                }
                // TODO: ??
                if(is_stripe_payment && this.params.price > originating_payment.price) {
                    this.presentAlert('Refund amount exceeds payment amount', 'Please enter a refund amount that is less than or equal to the payment amount');
                    reject();
                    return;
                }
                if(is_stripe_payment || !this.smartpay_connected) { // Stripe refunds will be handled by the api
                    this.presentSpinner("Adding refund payment").then(() => {
                        this.orderService.addOrderRefundPayment(this.order_id, this.refund_id, this.params).then(() =>{
                            this.orderService.getOrder(this.order_id).then((order) => {
                                if(order) {
                                    this.observerService.publish('order_updated', order);
                                    this.spinner.dismiss();
                                }
                                resolve();
                            })
                            .catch(() => {
                                this.spinner.dismiss();
                                reject();
                            });
                        })
                        .catch(() => {
                            this.spinner.dismiss();
                            reject();
                        });
                    });
                }
                else {
                    this.smartpay_transaction_start_time = Date.now();
                    this.smartpayRefundLoadingController();

                    let current_transaction_id:string;

                    let subscription = this.smartpayReaderService.transactionObservable.subscribe(payment_status => {
                        if (payment_status.transaction_id == current_transaction_id) {
                            if (payment_status.status == "success") {
                                delete this.params.originating_payment_id; // smartpay doesn't use the originating payment to refund against
                                this.params.price = payment_status.payment.price;
                                this.params.payment_service_transaction_id = payment_status.payment.payment_service_transaction_id;
                                this.params.payment_service_receipt_text = payment_status.payment.payment_service_receipt_text;
                                this.params.payment_service_id = "37CF49B6-9D0E-A6BE-BF18B291CAB60B65"; // smartpay
                                this.params.label = payment_status.payment.label;
                                this.params.method = payment_status.payment.method;
                                this.presentSpinner('Adding refund').then(() => {
                                    this.orderService.addOrderRefundPayment(this.order_id, this.refund_id, this.params).then(async () => {
                                        await this.spinner.dismiss();
                                        await this.modalController.dismiss();
                                    })
                                    .catch(() => {
                                        this.spinner.dismiss();
                                    });
                                });
                            } else if(payment_status.status == "declined") {
                                this.presentAlert("Problem", "Card declined");
                            } else if(payment_status.status == "failed") {
                                this.presentAlert("Problem", "Failed to refund card");
                            } else if(payment_status.status == "offline") {
                                this.presentAlert("Problem", "Smartpay reader is offline");
                            } else if(payment_status.status == "cancelled") {
                                this.presentAlert("Problem", "Refund cancelled");
                            } else if(payment_status.status == "service_unavailable") {
                                this.presentAlert("Problem", "Service unavailable");
                            }
                            // TODO: Handle DELAYED??
                            if(payment_status.status != "delayed") {
                                if(this.smartpay_refund_alert) this.smartpay_refund_alert.dismiss(true);
                                if(this.smartpay_refund_loading) this.smartpay_refund_loading.dismiss(true);
                                subscription.unsubscribe();
                            }
                        }
                    });

                    const price_cents = Number(new Decimal(this.params.price).times(100).toDecimalPlaces(0));
                    this.smartpayReaderService.refundCard(price_cents).then((transaction_id) => {
                        current_transaction_id = transaction_id;
                    }).catch(error => {
                        if(this.smartpay_refund_alert) this.smartpay_refund_alert.dismiss(true);
                        if(this.smartpay_refund_loading) this.smartpay_refund_loading.dismiss(true);
                        if(error == "unpaired") {
                            this.presentAlert("Problem", "The POS has been unpaired from the Smartpay reader. Cannot process refund");
                            this.smartpay_connected = false;
                            this.params.method = "cash";
                        } else if(error == "reader_busy") {
                            this.presentAlert("Problem", "The Smartpay reader is already processing a transaction");
                        } else if(error == "register_not_paired") {
                            this.presentAlert("Problem", "The Smartpay reader has been unpaired");
                        } else if(error == "service_unavailable") {
                            this.presentAlert("Problem", "Service unavailable");
                        }
                    });
                }
            }
            else {
                this.presentSpinner("Adding refund payment").then(() => {
                    this.orderService.addOrderRefundPayment(this.order_id, this.refund_id, this.params).then(() =>{
                        this.orderService.getOrder(this.order_id).then((order) => {
                            if(order) {

                                if(this.params.method == "cash") {
                                    this.observerService.publish('cash_tracking_session_changed', null);
                                }

                                this.observerService.publish('order_updated', order);
                                this.spinner.dismiss();
                            }
                            resolve();
                        })
                        .catch(() => {
                            this.spinner.dismiss();
                            reject();
                        });
                    })
                    .catch(() => {
                        this.spinner.dismiss();
                        reject();
                    });
                });
            }
        });
    }

    methodChanged() {

        if(this.params.method == 'cash') {
            this.cashDrawerService.open().then((result) => {
                if(result === 'failed') {
                    this.presentAlert("Unable to open cash drawer", "Please check your printer settings");
                }
            });
        }

        if(this.params.method != 'custom') {

            if(this.params.payment_service_id != undefined) {
                this.params.payment_service_id = undefined;
            }

            if(this.params.payment_service_transaction_id != undefined) {
                this.params.payment_service_transaction_id = undefined;
            }

        }

    }

    originatingPaymentChanged() {
        if(this.params.originating_payment_id) {
            let originating_payment = this.credit_card_payments.find(payment => payment.id == this.params.originating_payment_id);
            if(originating_payment && originating_payment.payment_service.friendly_id == "stripe") {
                this.params.price = originating_payment.price;
            }
            if(this.params.price > this.amount_due) {
                this.params.price = this.amount_due;
            }
        }
    }

    async presentDateTimePickerModal() {
        if(!this.date_picker_modal_open) {
            this.date_picker_modal_open = true;
            const modal = await this.modalController.create({
                component: DateTimePickerPage,
                cssClass: this.date_modal_css_class,
                componentProps: {
                    date: this.params['date'],
                    format: "date-time",
                    clear_date: false
                }
            })
            modal.onDidDismiss().then((data) => {
                this.date_picker_modal_open = false;
                if(data.data) {
                    this.params['date'] = data.data['date'];
                    this.formatted_date = this.moment(this.params['date']).format("D MMM YYYY, HH:mm");
                }
            });
            return await modal.present();
        }
        else {
            return null;
        }
    }

    async presentAlert(header, message) {
        const alert = await this.alertController.create({
            header: header,
            message: message,
            buttons: ["OK"],
        });
        await alert.present();
    }

    async presentSpinner(message) {
        this.spinner = await this.loadingController.create({
            message: message,
            showBackdrop: false,
            cssClass: 'loading-spinner'
        });
        await this.spinner.present();
    }

    async presentLoadingSpinner(message) {
        this.loading = true;
        this.loading_spinner = await this.loadingController.create({
            message: message,
            showBackdrop: false,
            cssClass: 'loading-spinner'
        });
        this.loading_spinner.onDidDismiss().then(() => {
            this.loading = false;
        });
        await this.loading_spinner.present();
    }

}